<template>
  <div class="pageWarp">

    <!-- 图表区域 -->
    <div class="chart-area boxs display_flex">
        <!-- 左边统计 -->
        <div class="chart-left">
            <div class="count-up-div flex_h_hS_vC">
                <div class="count-block flex_v_hL_vC">
                    <p class="first-text flex_h_hL_vC">
                        <img class="icon" src="@/assets/images/enjoy/orderManage/orderCount1.png" alt="">
                        <span>今日订单数</span>
                    </p>
                    <p class="second-text clamp_1">{{count_data.count1}}</p>
                </div>
                <div class="count-block flex_v_hL_vC">
                    <p class="first-text flex_h_hL_vC">
                        <img class="icon" src="@/assets/images/enjoy/orderManage/orderCount2.png" alt="">
                        <span>昨日订单数</span>
                    </p>
                    <div class="second-text clamp_1">{{count_data.count2}}</div>
                </div>
            </div>
            
            <div class="count-up-div flex_h_hS_vC">
                <div class="count-block flex_v_hL_vC">
                    <p class="first-text flex_h_hL_vC">
                        <img class="icon" src="@/assets/images/enjoy/orderManage/orderCount3.png" alt="">
                        <span>近7日订单数</span>
                    </p>
                    <p class="second-text clamp_1">{{count_data.count3}}</p>
                </div>
                <div class="count-block flex_v_hL_vC">
                    <p class="first-text flex_h_hL_vC">
                        <img class="icon" src="@/assets/images/enjoy/orderManage/orderCount4.png" alt="">
                        <span>本月订单数</span>
                    </p>
                    <div class="second-text clamp_1">{{count_data.count4}}</div>
                </div>
            </div>
            
            <div class="count-up-div flex_h_hS_vC">
                <div class="count-block flex_v_hL_vC">
                    <p class="first-text flex_h_hL_vC">
                        <img class="icon" src="@/assets/images/enjoy/orderManage/orderCount5.png" alt="">
                        <span>本年订单数</span>
                    </p>
                    <p class="second-text clamp_1">{{count_data.count5}}</p>
                </div>
                <div class="count-block flex_v_hL_vC">
                    <p class="first-text flex_h_hL_vC">
                        <img class="icon" src="@/assets/images/enjoy/orderManage/orderCount6.png" alt="">
                        <span>未竣工订单数</span>
                    </p>
                    <div class="second-text clamp_1">{{count_data.count6}}</div>
                </div>
            </div>
        </div>
        <!-- 右边图表 -->
      <div class="chart-right flex_1 boxs flex_v" v-if="thirtyDayOrderData.length != 0">
            <div class="com-header flex_h_hL_vC">
                <img class="icon" src="@/assets/images/enjoy/orderManage/chartIcon.png" alt="">
                <span>近30日订单趋势图</span>
            </div>

            <line-chart
              ref="rightChart"
              class="chart-div"
              :chartName="'近30日订单趋势图'"
              :chartData="thirtyDayOrderData"
            ></line-chart>
        </div>
    </div>


    <!-- 标题 -->
    <Title-Box :top-title="topTitle"></Title-Box>
    <!-- <div class="titleLine flex-row ite-c"><span>订单信息</span></div> -->

    <!-- 筛选框 -->
    <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
      <template slot="otherCom">

        <el-form-item>
          <el-date-picker
                  v-model="timeRange"
                  type="daterange"
                  unlink-panels
                  size="medium"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyyMMdd"
                  :picker-options="timePickerOptions"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-input
                  v-model="searchForm.params.orderId"
                  placeholder="请输入订单号"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
                  v-model="searchForm.params.serviceTelphone"
                  placeholder="请输入开户号码"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
                  v-model="searchForm.params.userName"
                  placeholder="请输入用户姓名"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
                  v-model="searchForm.params.certNo"
                  placeholder="请输入身份证号码"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
                  v-model="searchForm.params.contractPackageName"
                  placeholder="请输入套餐名称"
                  @keyup.enter.native="handleSearch"
                  maxlength="30" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
                  v-model="searchForm.params.thinningModels"
                  placeholder="请输入机型名称"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <!-- <el-form-item>
          <el-select v-model="searchForm.status"
                     @change="handleSearch" 
                     placeholder="选择订单状态" 
                     size="medium" clearable
                     filterable>
            <el-option 
                v-for="item in statusOptions" 
                :key="item.key" 
                :label="item.label" 
                :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item> -->

      </template>
    </sr-filter>


      <div class="summary_area boxs flex_h">
          <div @click="changeStatueEvent(-1)" class="summary_block boxs flex_v_hL_vC">
              <div class="first_text flex_h_hS_vC">
                  <span>累计冻结金额</span>
                  <span><small>{{data0.orderSumsNums}}</small>笔</span>
              </div>
              <div class="second_text clamp_1 flex_h ite-fe">
                  <span class="bigT">{{data0.sumFreezeMoney| centsToYuan}}</span> 元
              </div>
          </div>

          <div @click="changeStatueEvent(0)" class="summary_block boxs flex_v_hL_vC">
              <div class="first_text flex_h_hS_vC">
                  <span>待冻结</span>
                  <span><small>{{data1.orderSumsNums}}</small>笔</span>
              </div>
              <div class="second_text clamp_1 flex_h ite-fe">
                  <span class="bigT">{{data1.sumFreezeMoney| centsToYuan}}</span> 元
              </div>
          </div>

          <div @click="changeStatueEvent(1)" class="summary_block boxs flex_v_hL_vC">
              <div class="first_text flex_h_hS_vC">
                  <span>待竣工</span>
                  <span><small>{{data2.orderSumsNums}}</small>笔</span>
              </div>
              <div class="second_text clamp_1 flex_h ite-fe">
                  <span class="bigT">{{data2.sumFreezeMoney| centsToYuan}}</span> 元
              </div>
          </div>

          <div @click="changeStatueEvent(2)" class="summary_block boxs flex_v_hL_vC">
              <div class="first_text flex_h_hS_vC">
                  <span>已竣工</span>
                  <span><small>{{data3.orderSumsNums}}</small>笔</span>
              </div>
              <div class="second_text clamp_1 flex_h ite-fe">
                  <span class="bigT">{{data3.sumFreezeMoney| centsToYuan}}</span> 元
              </div>
          </div>

          <div @click="changeStatueEvent(4)" class="summary_block boxs flex_v_hL_vC">
              <div class="first_text flex_h_hS_vC">
                  <span>已关闭</span>
                  <span><small>{{data4.orderSumsNums}}</small>笔</span>
              </div>
              <div class="second_text clamp_1 flex_h ite-fe">
                  <span class="bigT">{{data4.sumFreezeMoney| centsToYuan}}</span> 元
              </div>
          </div>

      </div>

      <!-- <div class="summaryLine boxs">
          <span style="font-size:15px;">共查询到</span>
          <span style="font-size:20px; color:#333333;"> 22 </span>
          <span>&nbsp;笔，待冻结&nbsp;</span>
          <span style="font-size:20px; color:#2DBAA5;"> 1 </span>
          <span>&nbsp;笔，待竣工&nbsp;</span>
          <span style="font-size:20px; color:#2DBAA5;"> 1 </span>
          <span>&nbsp;笔，已竣工&nbsp;</span>
          <span style="font-size:20px; color:#2DBAA5;"> 1 </span>
          <span>&nbsp;笔，已关闭&nbsp;</span>
          <span style="font-size:20px; color:#2DBAA5;"> 1 </span>
          <span style="margin-right:40px;">&nbsp;笔</span>

          <span>合计：冻结金</span>
          <span style="font-size:20px; color:#FA6241;"> 3400.00 </span>
          <span style="margin-right:40px;">&nbsp;元</span>
      </div> -->


      <!-- 表格 -->
      <div class="botTable boxs tableTheadGray">
          <div class="tableTop">
              <span class="top_le">订单列表</span>
              <button class="butStyle pinkBtn exportBtn" @click="tableExportAll">
                <i class="exportIcon"></i>
                <span>导出</span>
              </button>
          </div>
          <el-table ref="multipleTable" :data="tableData" @selection-change="selsChange" style="width: 100%;" border fit highlight-current-row tooltip-effect="dark">
              <!-- 这是列表前面的多选框 -->
              <el-table-column type="selection" align="center" width="40"></el-table-column>
              <el-table-column label="订单号" prop="order_id" min-width="150" header-align="center" align="center"
                               show-overflow-tooltip></el-table-column>
              <el-table-column label="套餐" prop="contract_package_name" min-width="280" header-align="center"
                               align="center"
              >
                  <template slot-scope="scope">
                      <el-tooltip placement="top">
                          <div slot="content" style="line-height:20px;min-width:200px;">
                              套餐编号：{{scope.row.package_id}}<br/>
                              套餐档次：{{scope.row.grade}}<br/>
                              合约期(月)：{{scope.row.contract_period}}<br/>
                              权益直降款(元)：{{scope.row.straight_down_money | centsToYuan}}<br/>
                              返还总金额：{{scope.row.return_sum_money| centsToYuan}}<br/>
                              每月返还金额(元)：{{scope.row.return_month_money| centsToYuan}}<br/>
                              代收款总额：{{scope.row.collection_sum_money| centsToYuan}}<br/>
                              每月代收款金额(减收)：{{scope.row.collection_month_money| centsToYuan}}<br/>
                          </div>
                          <span class="greenT">{{scope.row.contract_package_name}}</span>
                      </el-tooltip>
                  </template>
              </el-table-column>
              <el-table-column label="套餐补贴额度（元）" prop="straight_down_money" width="150" header-align="center"
                               align="right"
                               show-overflow-tooltip>
                  <template slot-scope="scope" class="orangeText">
              <span class="orangeText">
                      {{scope.row.straight_down_money | centsToYuan}}
                </span>
                  </template>
              </el-table-column>
              <el-table-column label="机型" prop="thinning_models" min-width="250" header-align="center" align="center"
              >
                  <template slot-scope="scope">
                      <el-tooltip placement="top">
                          <div slot="content" style="line-height:20px;min-width:200px;">
                              是否5G终端：{{scope.row.terminal_type == 'Y'?"是":"否"}}<br/>
                              终端价格：{{scope.row.terminalPrice | centsToYuan}}<br/>
                              终端串码：{{scope.row.terminal_number}}<br/>
                              设备代理商：{{scope.row.store_name}}<br/>
                              设备代理商编号：{{scope.row.store_code}}<br/>
                              备注：{{scope.row.terminal_remark}}<br/>
                          </div>
                          <span class="greenT">{{scope.row.thinning_models}}</span>
                      </el-tooltip>
                  </template>
              </el-table-column>
              <el-table-column label="开户号码" prop="service_telphone" width="130" header-align="center" align="center"
                               show-overflow-tooltip></el-table-column>
              <el-table-column label="用户" prop="user_name" width="70" header-align="center" align="center"
              >
                  <template slot-scope="scope">
                      <el-tooltip placement="top">
                          <div slot="content" style="line-height:20px;min-width:200px;">
                              用户编号：{{scope.row.serv_id}}<br/>
                              身份证：{{scope.row.cert_no}}<br/>
                          </div>
                          <span class="greenT">{{scope.row.user_name}}</span>
                      </el-tooltip>
                  </template>
              </el-table-column>
              <el-table-column label="订单状态" prop="state_name" min-width="78" header-align="center" align="center"
                               show-overflow-tooltip>
                  <template slot-scope="scope">
                <span :class="{lightGT:scope.row.state_name=='待冻结', orangeT:scope.row.state_name=='待竣工', grayT:scope.row.state_name=='已竣工'}">
                  {{scope.row.state_name}}
                </span>
                  </template>
              </el-table-column>
              <el-table-column label="冻结金(元)" prop="freeze_money" width="140" header-align="center" align="right"
                               show-overflow-tooltip>
                  <template slot-scope="scope" class="orangeText">
              <span class="orangeText">
                      {{scope.row.freeze_money | centsToYuan}}
                </span>
                  </template>
              </el-table-column>
              <el-table-column label="受理人" prop="store_name" min-width="180" header-align="center" align="center"
                               show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" width="108" header-align="center" align="center"
                               show-overflow-tooltip>
                  <template slot-scope="scope">
                      <el-button @click="goDetailPage(scope)"
                                 class="greenT"
                                 icon="el-icon-success"
                                 type="text"
                                 title="审核订单" v-if="scope.row.reward_status == ''">审核订单
                      </el-button>
                      <el-button @click="goDetailPage(scope)"
                                 class="greenT"
                                 type="text"
                                 title="详情">
                                 <i class="order-icon"></i>
                                 详情
                      </el-button>
                  </template>
              </el-table-column>
              <el-table-column label="登记" prop="" fixed="right" width="120" header-align="center" align="center"
                               show-overflow-tooltip>
                  <template slot-scope="scope">
                      <el-button @click="open(scope)" 
                                 type="button"
                                 class="logBtn"
                                 title="录入登记">录入登记
                      </el-button>
                  </template>
              </el-table-column>
          </el-table>
          <div class="pageBox boxs">
              <el-pagination @size-change="handleSizeChange"
                             @current-change="handleCurrentChange"
                             :current-page="searchForm.current"
                             :page-sizes="[10, 20, 30]"
                             :page-size="searchForm.size"
                             layout="total, sizes, prev, pager, next, jumper" :total="total">
              </el-pagination>
          </div>
      </div>


  </div>
</template>

<script>
    import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
    import SrFilter from '@/components/Common/Filter/Filter';
    import lineChart from './components/LineChart'
    import {formatDate} from '@/utils/dateFormatter';
    import {objectToQueryString} from '@/utils/commonUtils.js';

    import {
        orderCurrentMonthEveryDayNums,
        orderDateGroupNums,
        orderlist,
        orderTypeGroupNums,
        logRegister
    } from '@/api/Tbs/OrderManage/orderManage.js'

    // 搜索表格的条件-筛选栏
    const defaultSearchForm = {
        params: {
            // 其他请求参数
            orderId: null, //订单号
            serviceTelphone: null, //开户号码
            userName: null, //用户姓名
            certNo: null, //身份证号码
            contractPackageName: null, //套餐名称
            thinningModels: null, //机型名称
            statusList: [], //订单状态
        },
        current: 1,
        size: 10
    }

    export default {
        name: "OrderManageIndex",
        data() {
            return {
                //标题
                topTitle: {
                    title: '订单信息',
                    subTit: ''
                },
                count_data: {
                    count1: 0,
                    count2: 0,
                    count3: 0,
                    count4: 0,
                    count5: 0,
                    count6: 0,
                },
                data0: {},
                data1: {},
                data2: {},
                data3: {},
                data4: {},
                // 近30日订单数据
                thirtyDayOrderData: [],

                timeRange: null,
                // 表格搜索条件
                searchForm:this.initSearchParams(),
                // 全部状态
                statusOptions: [
                    {key: 1, label: '待冻结'},
                    {key: 2, label: '待竣工'},
                    {key: 3, label: '已竣工'},
                    {key: 4, label: '已关闭'},
                ],


                // 表格数据
                tableData: [],
                // 表格数据总数
                total: 0,
                // 日期时间选择器
                timePickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [
                        {
                            text: '今天',
                            onClick(picker) {
                                picker.$emit('pick', [new Date(), new Date()])
                            }
                        },
                        {
                            text: '昨天',
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(start.getTime() - 3600 * 1000 * 24)
                                picker.$emit('pick', [start, end])
                            }
                        },
                        {
                            text: '最近三天',
                            onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },
        sels:[]
      }
    },
    computed: {
      // 开始时间
      min_accept_time() {
        return this.timeRange ? this.timeRange[0] : null
      },
      // 结束时间
      max_accept_time() {
        return this.timeRange ? this.timeRange[1] : null
      }
    },
    components: {
      SrFilter,
      TitleBox,
      lineChart
    },
    created() {
        this.initSearchParams()
        this.loadDataCount()
        this.getThirtyDayOrderData()
        this.getDataList()
    },
    methods: {
        selsChange(sels) {
          console.log('hhhhhhh')
          this.sels = sels
          console.log('this.sels',this.sels);
        },
        //20201203新增一个按钮
         open(scope) {
          // console.log(scope.row.state_name); 
          this.$prompt('请输入手机号码', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern:/^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/,
            inputErrorMessage: '手机号码格式不正确'
          }).then(({ value }) => {
            this.$message({
              type: 'success',
              message: '你的手机号码是: ' + value
            });
            var data={
                'id':scope.row.id,
                'serviceTelphone' : value,
            }
            logRegister(data).then( (res) =>{
              console.log(data);
              this.getDataList();
              if(res.code == 0){
                console.log('成功')
              }else{
                console.log('失败')
              }
            }).catch((error) => {
              console.log(error)
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });       
          });
        },
        tableExportAll() {
            // this.searchForm.params.beginTime = this.min_accept_time
            // this.searchForm.params.endTime = this.max_accept_time
            // var url = `${this.$baseUrl}/!Busi/Financial/Withdraw/~query/Q_WITHDRAW.Q_REVIEW_DETAILS?_exeresult=excel&${objectToQueryString(this.searchForm)}`;
            // console.log(url)
            // window.open(url, '_blank');
          if(this.sels== undefined || this.sels== ''){
            this.$message.error('请勾选具体订单列表！！！');
          }else{
            let orderIds = this.sels.map((item) => item.order_id).join()
            console.log('id',orderIds);
            const url = `${this.$baseNewUrl}esaleb-service-tbs/TbsTelecomOrder/export?orderIds=${orderIds}&accessToken=${this.$accessToken()}`;
            window.open(url, '_blank');
          }  
        },
        formatDefault: function (date) {
            return formatDate(date, 'yyyyMMdd');
        },
        // 获取顶部统计数据
        async loadDataCount() {
            try {
                const result = await orderDateGroupNums();
                console.log(result)
                this.count_data.count1 = result.data.orderTodayNums;
                this.count_data.count2 = result.data.orderYesTodayNums;
                this.count_data.count3 = result.data.orderWeekNums;
                this.count_data.count4 = result.data.orderMonthNums;
                this.count_data.count5 = result.data.orderYearNums;
                this.count_data.count6 = result.data.orderUnfinishNums;

            } catch (e) {
                this.$message.error('接口请求失败:' + e.msg);
            }
        },
        // 获取查询订单分类统计数据
        async orderTypeGroupNums() {
            try {
                const result = await orderTypeGroupNums(this.searchForm.params);
                console.log(result)
                this.data0 = result.data[0];
                this.data1 = result.data[1];
                this.data2 = result.data[2];
                this.data3 = result.data[3];
                this.data4 = result.data[4];

            } catch (e) {
                this.$message.error('接口请求失败:' + e.msg);
            }
        },

        // 获取近30日订单数据
        async getThirtyDayOrderData() {
            try {
                const result = await orderCurrentMonthEveryDayNums();
                console.log(result)
                this.thirtyDayOrderData = result.data;
                console.log(this.thirtyDayOrderData)
            } catch (e) {
                this.$message.error('接口请求失败:' + e.msg);
            }
        },

        // 点击切换订单状态
        changeStatueEvent(msg) {
            this.searchForm.params.statusList = []
            if (msg == 4 && msg != -1) {
                this.searchForm.params.statusList = [3, 4, 5];
            } else if (msg != -1) {
                this.searchForm.params.statusList.push(msg);
            }
            this.getDataList();
        },
        async getDataList() {
            try {
                this.searchForm.params.beginTime = this.min_accept_time
                this.searchForm.params.endTime = this.max_accept_time
                console.log(this.searchForm)
                const result = await orderlist(this.searchForm);
                console.log(result)
                this.tableData = result.data.records
                this.total = result.data.total
                console.log(this.tableData)

                this.orderTypeGroupNums();
            } catch (e) {
                this.$message.error('接口请求失败:' + e.msg);
            }
        },

        // 列表过滤查询
        handleSearch() {
            console.log('搜索')
            this.getDataList();
        },
      initSearchParams() {
        return this.$deepClone(defaultSearchForm);
      },
        // 搜索重置（清空）
        handleReset() {
            // 初始化参数
          this.searchForm = this.initSearchParams()
            this.timeRange = null;
            // 获取表格数据
            this.getDataList()
        },
        // 列表每页条数变了
        handleSizeChange(val) {
            this.searchForm.size = val
            this.getDataList()
        },
        // 列表当前页码变了
        handleCurrentChange(val) {
            this.searchForm.current = val
            this.getDataList()
        },


        // 跳转到详情页
        goDetailPage(scope) {
            this.$router.push({
                path: '/tbs/orderManage/orderDetail',
                query: {
                    id: scope.row.id
                }
            })
        },

    },
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  /* 文字顔色 */
  /* 浅绿 */
  .blackT {
    color: #4E4A46;
  }

  .greenT {
    color: #2DBAA5;
  }

  .lightGT {
    color: #76C819;
  }

  .orangeT {
    color: #FA6241;
  }

  .grayT {
    color: #B7B2AF;
  }



  .pageWarp {
    min-width: 1080px;
  }



  // 图表区域
  .pageWarp .chart-area {
    margin: 0;
    padding: 0;
  }

  // 图表区域-左边统计
  .chart-area .chart-left {
  }
  .chart-area .chart-left .count-up-div {
    margin-bottom: 12px;
  }
  .chart-area .chart-left .count-block{
    width: 200px;
    height: 93px;
    background: #fff;
    // border-radius: 5px;
    box-sizing: border-box;
    padding: 16px 14px;
    color: #B7B2AF;
    font-size: 12px;
    margin-right: 12px;
    white-space: nowrap;
  }
  // .chart-area .chart-left .count-block:last-of-type{
  //   margin-right: 0;
  // }
  .chart-area .chart-left .count-block .first-text{
    margin-bottom: 10px;
  }
  .chart-area .chart-left .count-block .first-text .icon{
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .chart-area .chart-left .count-block .second-text{
    line-height: 35px;
    color: #333333;
    font-size: 26px;
  }

  // 图表区域-右边图表
  .chart-area .chart-right {
    height: 303px;
    box-sizing: border-box;
    padding: 16px 16px 10px;
    background: #fff;
    // background: #666666;
  }
  .chart-right .com-header {
    width: 100%;
    height: 16px;
    box-sizing: border-box;
    padding: 0 0 0 0;
    // background: #f7f7f7;
  }
  .chart-right .com-header .icon {
    width: 14px;
    height: 16px;
    margin-right: 6px;
  }
  .chart-right .com-header span {
    color: #302C2C;
    font-size: 12px;
    font-weight: bold;
  }
  .chart-right .chart-div {
    // height: calc( 303px - 16px - 10px - 16px );
    height: calc( 100% - 16px );
  }



  // 标题
  .pageWarp .titleLine {
    width: 100%;
    height: 20px;
    margin-top: 12px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  .titleLine span {
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
  }

  .titleLine span::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 20px;
    margin-right: 6px;
    background: #FA6241;
    vertical-align: middle;
  }



  // 筛选框
  .pageWarp .searchBox {
    // min-height: 64px;
    margin-top: 0px;
  }



  // 总结栏-文字
  .pageWarp .summaryLine {
    // height: 72px;
    line-height: 26px;
    margin-top: 14px;
    padding: 23px 20px;
    background: #ffffff;
    font-size: 12px;
    color: #333333;
  }


  // 总结
  .pageWarp .summary_area {
    flex-wrap: wrap;
  }
  .pageWarp .summary_block {
    margin-top: 12px;
    width: 207px;
    height: 72px;
    background: #fff;
    // border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 20px;
    font-size: 12px;
    color: #333333;
    white-space: nowrap;
    margin-right: 14px;
  }
  .pageWarp .summary_block .first_text{
    min-width: 160px;
    max-width: 100%;
    margin-bottom: 6px;
  }
  .pageWarp .summary_block .first_text small{
    color: #2DBAA5;
    margin-right: 3px;
  }
  .pageWarp .summary_block .second_text{
    // line-height: 16px;
    height: 20px;
  }
  .pageWarp .summary_block .second_text span.bigT{
    height: 20px;
    color: #FA6241;
    font-size: 20px;
    font-weight: normal;
    margin-right: 3px;
  }



  // 表格
  .pageWarp .botTable {
    margin-top: 12px;
    width: 100%;
    // max-height: 408px;
  }

  .botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
    position: relative;
  }

  .botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
  }

  .botTable .tableTop .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;
    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .botTable .tableTop .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
  }

  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;
    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }
  .logBtn{
    background-color: #FA6241;
    color: #FFFFFF;
  }
  .order-icon[data-v-856eab02] {
    display: inline-block;
    width: 14px;
    height: 11.22px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAXCAYAAAAYyi9XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4ElEQVRIie3Rv0vUcRzH8efr8/3e9zy1CCkzL8LgpLh+XFCLbVK45VQHTeHQFNdSc44tjhEUyCUhHE6RJtkPqMFcahJFyqAhIxIzSLk87/t5t/gnfJzqub2mx/DSyRe1AUjvCQ6DTf5e2b72ZWjoT/FZtUtJMkDgYpGOAAVAoMt7upOnwHik7DHMRoODBt0C7WyHoxPAlEq4ODgI9sjghlACfPOyGQDFWjPPVHAwu7V5p560f3TYEY+fXLzweQlgfj1ZLB7gamgQgLPvH2QK09NZbNjtCvBPJYC+dxO51V+NzPJGskm5nO4qWHo9lvdpXDHsKFDbn8lPvunvb/ZUqy25zuRgaDBO0/iu4IqkCOPi6vbKIDDb2h2VnHgcHBR2CdSCAdAhUx8w67xyiugNDoI+YNaP5IA6kS0BmGlb8CM46Jt208W6j1neQ22r0fESYAvmE3ODoUEBOjU1vs/lmq1ra7mfX8vlemjkf7uasGF35knP3npbS2tHe7Q+d37nQxt2fXMnsqHBuPjqeClts4cZS/Mbm76G2W0kf/p5oXfDNW4FByPzFeCcJPBUijNjo4uw4OGQpOvBQQMvMCTAFGeiJoCiyDDzwUGZRpCVMOvynomFt8ufAJSm333kqqHBv+LXsmxzYtRFAAAAAElFTkSuQmCC) no-repeat;
    background-size: 14px 11.22px;
}
</style>
